import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  authenticatedToken: null,
};

const authSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    setAuthenticationToken: (state, { payload }) => {
      state.authenticatedToken = payload;
    },
    removeAuthenticationToken: (state, { payload }) => {
      state.authenticatedToken = payload;
      localStorage.removeItem("persist:root");
    },
  },
});

export const { setAuthenticationToken, removeAuthenticationToken } =
  authSlice.actions;
export default authSlice.reducer;
